
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import { ListItem, WorkflowApproval } from '../../backend/backendapi';
import { formatDateTime } from '../../../util';
import ApprovalApproveModal from './ApprovalApproveModal';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'ApprovalListTable',
  components: { ApprovalApproveModal },
})
export default class ApprovalListTable extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  formatDateTime = formatDateTime;

  get usersById(): Map<string, ListItem> {
    return new Map(this.state.users.map(e => [e.id!, e]));
  }

  getUsername(id: string): string {
    return (this.usersById.get(id)?.firstName ?? '') + ' ' + (this.usersById.get(id)?.lastName ?? '');
  }

  openRequest(request: WorkflowApproval): void {
    return (this.$refs.approveModal as ApprovalApproveModal).open(request);
  }
}
